import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/gridsConfirmationModal";
import deltas from "../../actions/deltas";

const {SET_GRIDS_CONFIRMATION_MODAL_STATE} = deltas.actionTypes;

export default createStateReducer(states, states.CLOSED, SET_GRIDS_CONFIRMATION_MODAL_STATE);

export const selectGridsConfirmationModalState = state => state.states.gridsConfirmationModal.state;
